/**
 * @module components/memorable-date-ui
 * @description Barrel export for memorableDateUI component
 */

export { MemorableDateUI } from './memorable-date-ui';
